import React, { useEffect, useState } from 'react';

import { APPLY_WORK_FORM_URL, CONTRACT_TYPE } from '../../constants';
import { TypeContract } from '../../types';

import styles from './MenuDrawerBanner.module.scss';

const MenuDrawerBanner = ({ contractType, closeDrawer }: { contractType?: TypeContract; closeDrawer: () => void }) => {
  const [bannerConfig, setBannerConfig] = useState<{
    show: boolean;
    url: string;
  }>({
    show: false,
    url: '',
  });

  useEffect(() => {
    /** 아르바이트인 경우, 근무신청 배너 표시 */
    if (contractType === CONTRACT_TYPE.SHORT) {
      setBannerConfig({
        show: true,
        url: APPLY_WORK_FORM_URL,
      });
    } else {
      /** 상용직인 경우, 배너 미표시 */
      setBannerConfig({
        show: false,
        url: '',
      });
    }
  }, [contractType]);

  const handleBannerClick = () => {
    if (!bannerConfig.url) return;

    const formWindow = window.open(bannerConfig.url);
    if (formWindow) {
      closeDrawer();
    }
  };

  return (
    bannerConfig.show && (
      <div className={styles['drawer-banner-container']}>
        <button
          className={`${styles['banner-image']} ${contractType === CONTRACT_TYPE.CONTRACT ? styles['contract'] : ''}
    ${contractType === CONTRACT_TYPE.SHORT ? styles['short'] : ''}`}
          onClick={handleBannerClick}
        />
      </div>
    )
  );
};

export default MenuDrawerBanner;
